module.exports = __webpack_public_path__ + "static/media/balckHeart.ade81fc8.svg";